import { ALL_EVENTS } from './constants';

export default function normalizeEventName(value) {
  return value || ALL_EVENTS;
}
